import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const ExportRfidCategory = ({ rfidCategoryData }) => {
  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Asset Categories");
    const boldFont = { bold: true };

    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Asset Category Details Generated on: ${formattedDate}, ${formattedTime}`;

    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 5);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    worksheet.addRow(["", "", "Asset Category Details", ""]);
    worksheet.mergeCells(2, 2, 2, 5);
    worksheet.getCell(2, 2).value = "Asset Category Details";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Asset Type",
      "Asset Category",
      "Status",
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 4) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "003366" },
          bgColor: { argb: "FFFFFFFF" },
        };
      }
    });

    rfidCategoryData.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.rfidTypeName || "N/A",
          item.categoryName || "N/A",
          item.isActive ? "Active" : "InActive",
        ])
        .eachCell({ includeEmpty: true }, (cell) => {
          cell.alignment = { horizontal: "center" };
        });
    });

    worksheet.columns = [{ width: 5 }, { width: 20 }, { width: 20 }, { width: 20 }];

    try {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "RfidCategoryDetails.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating Excel file:", error);
    }
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Asset Category Report Generated on: ${formattedDate} ${formattedTime}`;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("Asset Category Details", 14, 20);
    doc.setFontSize(12);
    doc.text(downloadDateTime, 14, 30);

    const tableColumn = ["S.No", "Asset Type", "Asset Category", "Status"];
    const tableRows = rfidCategoryData.map((row, index) => [
      index + 1,
      row.rfidTypeName || "N/A",
      row.categoryName || "N/A",
      row.isActive ? "Active" : "InActive",
    ]);

    autoTable(doc, {
      startY: 40,
      head: [tableColumn],
      body: tableRows,
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 2,
        overflow: "linebreak",
        valign: "middle",
      },
      headStyles: {
        fillColor: [0, 51, 102],
        textColor: [255, 255, 255],
        fontStyle: "bold",
      },
      bodyStyles: {
        fontSize: 8,
        halign: "left",
      },
    });
    doc.save("RfidCategoryDetails.pdf");
  };

  return (
    <>
      <button onClick={exportToExcel} className="button-container ms-3">
        <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
      </button>
      <button onClick={exportToPDF} className="button-container ms-3">
        <i className="fa-solid fa-file-pdf me-1 icon-container"></i> PDF
      </button>
    </>
  );
};
